import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78b8a8e4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=78b8a8e4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b8a8e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b8a8e4')) {
      api.createRecord('78b8a8e4', component.options)
    } else {
      api.reload('78b8a8e4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78b8a8e4&scoped=true", function () {
      api.rerender('78b8a8e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/home/index.vue"
export default component.exports